import { serverConfig } from '@/config/server.config'
import type { UserActivityLogPayload } from '@/types/userActivity'

/**
 * Log a user action to the dashboard service.
 * This is a fire-and-forget operation - errors are intentionally swallowed so user flow is not blocked.
 */
export async function logUserAction(
  payload: UserActivityLogPayload,
): Promise<void> {
  try {
    await fetch(
      `${serverConfig.digitalCommunicationsApiUrl}/dashboard/logUserAction`,
      {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      },
    )
  } catch (_error) {
    // Fire-and-forget logging should never interrupt the caller.
  }
}
